import styled, { keyframes, css } from 'styled-components';
import { SpinnerProps, SpinnerSize } from './types';
import { theme } from '../../theme/default';

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

function getSize(props: SpinnerProps) {
  switch (props.size) {
    case SpinnerSize.LARGE:
      return css`
        height: ${theme.spacings['800']};
        width: ${theme.spacings['800']};
        border: ${theme.spacings['400']} solid ${theme.colors.neutral['300']};
        border-top: ${theme.spacings['400']} solid currentColor;
      `;
    case SpinnerSize.MEDIUM:
      return css`
        height: ${theme.spacings['600']};
        width: ${theme.spacings['600']};
        border: ${theme.spacings['300']} solid ${theme.colors.neutral['300']};
        border-top: ${theme.spacings['300']} solid currentColor;
      `;
    case SpinnerSize.SMALL:
    default:
      return css`
        height: ${theme.spacings['500']};
        width: ${theme.spacings['500']};
        border: ${theme.spacings['200']} solid ${theme.colors.neutral['300']};
        border-top: ${theme.spacings['200']} solid currentColor;
      `;
  }
}

export const SpinnerStyled = styled.div<SpinnerProps>`
  animation: ${spin} 0.5s linear infinite;
  border-radius: ${theme.radii['900']};
  cursor: wait;
  ${getSize}
`;
